var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-connector d-flex flex-column align-items-center my-1"},[_c('div',{staticClass:"connector-line",class:_vm.lineClass}),_vm._v(" "),_c('span',{staticClass:"connector-chip category-chip",class:_vm.chipClass},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"connector-line",class:_vm.lineClass})])
}
var staticRenderFns = []

export { render, staticRenderFns }